import { computed, inject, Injectable, signal } from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { forkJoin } from 'rxjs';
import { UserService } from './user/user.service';
import { LanguageService } from './language/language.service';

export enum WATCHED_FOR_OPEN {
  GAMES = 'game-list-open',
  TOURNAMENTS = 'tournament-list-open',
  OFFERS = 'promotion-list-open'
}

@Injectable({
  providedIn: 'root'
})
export class BadgeService {
  private _api = inject(CmsApiService);
  _user = inject(UserService);
  _lang = inject(LanguageService);


  public gameBadge = signal<any>(null);
  public promotionBadge = signal<any>(null);
  public tournamentBadge = signal<any>(null);

  public gameBadgeAllowance = computed(() => this.gameBadge() && this._user.auth)
  /**
   * Load all badges by main Entitys
   */
  private _checkBadgeUpdates() {
    forkJoin([
      this._api.gameBadgeList(),
      this._api.promotionBadgeList(),
      this._api.tournamentBadgeList()
    ])
    .subscribe(([gameBadge, promotionBadge, tournamentBadge]) => {
      this.gameBadge.set(gameBadge?.isUpdated || gameBadge?.data?.isUpdated);
      this.tournamentBadge.set(tournamentBadge?.isUpdated || tournamentBadge?.data?.isUpdated);
    });
  }

  /**
   * Load & show badges in menu if user auth
   */
  public loadBadgeInfo() {
    if (this._user.auth) {
      this._checkBadgeUpdates();
    }
  }

  /**
   * Send POST request if user watched some entity list
   * @param slug
   * @param params
   */
  public openListEntity(slug: string) {
    if (this._user.auth) {
      this._api.postListEntityOpen(slug).subscribe(() => this.deleteBadgeOn(slug));
    }
  }

  /**
   * Delete badge on item by slug
   * @param slug
   */
  public deleteBadgeOn(slug) {
    switch (slug) {
      case WATCHED_FOR_OPEN.GAMES :
        this.gameBadge.set(null);
        break;
      case WATCHED_FOR_OPEN.TOURNAMENTS :
        this.tournamentBadge.set(null);
        break;
      case WATCHED_FOR_OPEN.OFFERS :
        this.promotionBadge.set(null);
        break;
    }
  }
}
